/**
 * Os itens da lista "Configuração da empresa" (card da Visão Geral e de
 * Ajustes). A lista é CALCULADA no servidor (`GET /company-config/checklist`):
 * chave, estado e o texto do que falta vêm de lá; os rótulos e a frase do
 * que cada item garante são daqui.
 *
 * **Espelho do vocabulário do servidor** — a ordem e as chaves têm teste de
 * paridade que lê ESTE arquivo por fonte, então os dois arrays ficam como
 * literais `as const`, um valor por linha.
 */

export const COMPANY_CHECKLIST_ITEMS = [
  "main_brand_terms",
  "polarity_rules",
  "prompt_models",
  "network_channels",
  "vehicles",
  "publisher_default_tier",
  "themes",
] as const;

export type CompanyChecklistKey = (typeof COMPANY_CHECKLIST_ITEMS)[number];

export const COMPANY_CHECKLIST_STATUSES = [
  "missing",
  "warning",
  "ok",
] as const;

export type CompanyChecklistStatus = (typeof COMPANY_CHECKLIST_STATUSES)[number];

export const COMPANY_CHECKLIST_LABEL: Record<CompanyChecklistKey, string> = {
  main_brand_terms: "Marca principal com termos",
  polarity_rules: "Premissas de polaridade",
  prompt_models: "Modelo de IA por tarefa",
  network_channels: "Canais de rede",
  vehicles: "Veículos de imprensa",
  publisher_default_tier: "Porte do publicador (faixa de queda)",
  themes: "Subtemas",
};

/** O que cada item garante — a frase curta que explica por que ele está na lista. */
export const COMPANY_CHECKLIST_HELP: Record<CompanyChecklistKey, string> = {
  main_brand_terms: "Sem termos a marca nunca casa com uma publicação.",
  polarity_rules:
    "As premissas de cada polaridade e o contexto geral da classificação (GLOBAL), que alimentam o prompt de sentimento.",
  prompt_models: "Sem modelo a IA não classifica a polaridade, o papel nem os subtemas.",
  network_channels: "Linha de rede sem canal cadastrado vai pra fila de correção.",
  vehicles: "Linha de imprensa sem veículo cadastrado vai pra fila de correção.",
  publisher_default_tier: "Dá peso ao publicador que não cai em nenhuma faixa de seguidores.",
  themes: "Sem subtemas as menções não ganham classificação temática.",
};
